// Inputs for a data source's per-step settings (Clay's spend cap, Notion's
// pages and so on), rendered from the catalog's `step_fields` so a new source
// needs no UI work. Rendered in the data-source pill's panel; the agent step
// only opts in.

import type { DataSourceOption } from "../../../api/client.ts";
import FieldSpecInputs from "../../../components/fields/FieldSpecInputs.tsx";
import { fieldDefaults } from "../../../components/fields/fieldSpecs.ts";

/** What a freshly opted-in source starts with: each field's default, else null. */
export function defaultsFor(option: DataSourceOption): Record<string, unknown> {
  return fieldDefaults(option.step_fields);
}

export default function DataSourceFieldInputs({
  option,
  config,
  onChange,
  disabled,
}: {
  option: DataSourceOption;
  config: Record<string, unknown>;
  onChange: (config: Record<string, unknown>) => void;
  disabled: boolean;
}) {
  // A money cap's bare "USD" reads better with what it caps.
  const fields = option.step_fields.map((f) =>
    f.type === "number" && f.help_text === "USD" ? { ...f, help_text: "USD, per run of this step." } : f,
  );
  return (
    <FieldSpecInputs
      fields={fields}
      fieldOptions={option.field_options}
      values={config}
      onChange={onChange}
      disabled={disabled}
    />
  );
}
